/**
 * LAS 68 LINEAS DE LA LISTA DE MADERINCO, CON SU ITEM DEL CATALOGO (MADERINCO-LISTA-ITEMS-SECCIONES-T1).
 *
 * DATO GENERADO, no se edita a mano: sale de la tabla de A (bitacora #33745, notas.documento_md; verificada por Q
 * #33746 y #33758) con scratchpad/gen-capitulos.mjs. sha256 del texto leido: d3486bf62cf1e26ca7563b96217ee015eb6e181a3f74c3723403aef12374b6a8.
 * fuenteIds = el id libro:hoja:celda que trae cada item de GET /presupuestos/plantilla (campo fuenteId), con las
 * abreviaturas del documento expandidas (P, V, M, C, D, H, A).
 *
 * @module application/presupuestos/lineasDelCliente
 */

export const LINEAS_SHA256 = 'd3486bf62cf1e26ca7563b96217ee015eb6e181a3f74c3723403aef12374b6a8';

export const LINEAS_DEL_CLIENTE = [
  {
    "capitulo": 1,
    "linea": "Cimentacion, pilotes, cargueras, durmientes",
    "obligatoria": true,
    "opciones": [],
    "seccionCatalogo": "ESTRUCTURA DE PISO (3./5.)",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A30",
      "1346:PRESUPUESTO - 1C:B46",
      "APU:APU:F5"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 1,
    "linea": "Piso duro",
    "obligatoria": false,
    "opciones": [
      "superboard",
      "steel deck"
    ],
    "seccionCatalogo": "ESTRUCTURA DE PISO / HALL DE ENTRADA",
    "fuenteIds": [
      "1347:PRESUPUESTO CASA:A28",
      "1346:PRESUPUESTO - HALL:B21",
      "4546:PRESUPUESTO CASA:A31"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": "steel deck: por confirmar"
  },
  {
    "capitulo": 1,
    "linea": "Deck",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "ESTRUCTURA DE PISO / DECKS",
    "fuenteIds": [
      "1347:PRESUPUESTO CASA:A29",
      "1346:PRESUPUESTO - 1C:B47",
      "APU:APU:J5"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 1,
    "linea": "Filtros",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "ESTRUCTURA DE PISO",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A32"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 2,
    "linea": "Paredes externas",
    "obligatoria": false,
    "opciones": [
      "tablilla pared",
      "tablilla botagua",
      "perfil machihembrado",
      "superboard",
      "drywall",
      "muro mamposteria"
    ],
    "seccionCatalogo": "ESTRUCTURA DE PAREDES / PARED EXTERIOR / MURO CULATA EN LADRILLO",
    "fuenteIds": [
      "1346:PRESUPUESTO - 1C:B20",
      "1346:PRESUPUESTO - 1C:B23",
      "4546:PRESUPUESTO CASA:A20",
      "APU:APU:B17",
      "4546:PRESUPUESTO CASA:A21",
      "1346:PRESUPUESTO - 1C:B33"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 2,
    "linea": "Paredes internas",
    "obligatoria": false,
    "opciones": [
      "tablilla techo",
      "botagua",
      "perfil",
      "superboard",
      "drywall",
      "mamposteria"
    ],
    "seccionCatalogo": "ESTRUCTURA DE PAREDES / PARED INTERIOR",
    "fuenteIds": [
      "1346:PRESUPUESTO - 1C:B24",
      "APU:APU:B7",
      "4546:PRESUPUESTO CASA:A23"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": "botagua, perfil y mamposteria internos: por confirmar"
  },
  {
    "capitulo": 2,
    "linea": "Divisiones en madera inmunizada",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "ESTRUCTURA DE PAREDES",
    "fuenteIds": [
      "1347:PRESUPUESTO CASA:A21"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 2,
    "linea": "Cuchillas y encoroce",
    "obligatoria": true,
    "opciones": [],
    "seccionCatalogo": "ESTRUCTURA DE PAREDES / Cuchillas, encoroce y moldura",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A25",
      "APU:APU:J21",
      "1346:PRESUPUESTO - 1C:B26"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 2,
    "linea": "Moldura",
    "obligatoria": true,
    "opciones": [],
    "seccionCatalogo": "ESTRUCTURA DE PAREDES / CARPINTERIA EN MADERA",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A26",
      "APU:APU:J22",
      "1346:PRESUPUESTO - 1C:B79"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 2,
    "linea": "Tralisio en madera inmunizada",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": null,
    "fuenteIds": [],
    "porConfirmar": true,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 2,
    "linea": "Refuerzo de paredes",
    "obligatoria": true,
    "opciones": [
      "PTS",
      "Abarco"
    ],
    "seccionCatalogo": "ESTRUCTURA DE PAREDES / ESTRUCTURA METALICA EN PTS",
    "fuenteIds": [
      "1347:PRESUPUESTO CASA:A24",
      "1342:PRESUPUESTO CASA:A27",
      "4546:PRESUPUESTO CASA:A27"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 3,
    "linea": "Alfardado en madera inmunizada",
    "obligatoria": true,
    "opciones": [],
    "seccionCatalogo": "ESTRUCTURA DE CUBIERTA",
    "fuenteIds": [
      "1346:PRESUPUESTO - 1C:B12",
      "1347:PRESUPUESTO CASA:A12",
      "1342:PRESUPUESTO CASA:A12"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 3,
    "linea": "Permotif (permofit)",
    "obligatoria": true,
    "opciones": [],
    "seccionCatalogo": "ESTRUCTURA DE CUBIERTA",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A12",
      "4546:PRESUPUESTO CASA:A12",
      "1347:PRESUPUESTO CASA:A12"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": true,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 3,
    "linea": "Caballete",
    "obligatoria": false,
    "opciones": [
      "madera inmunizada",
      "abarco",
      "PTS"
    ],
    "seccionCatalogo": "ESTRUCTURA DE CUBIERTA / HALL",
    "fuenteIds": [
      "1347:PRESUPUESTO CASA:A12",
      "1346:PRESUPUESTO - HALL:B16",
      "1342:PRESUPUESTO CASA:A12"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 3,
    "linea": "Enchape tablilla de techo inmunizada",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "ESTRUCTURA DE CUBIERTA",
    "fuenteIds": [
      "4546:PRESUPUESTO CASA:A12",
      "1347:PRESUPUESTO CASA:A12",
      "1342:PRESUPUESTO CASA:A12"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 3,
    "linea": "Enchape superboard",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "ESTRUCTURA DE CUBIERTA",
    "fuenteIds": [
      "1346:PRESUPUESTO - 1C:B13",
      "1346:PRESUPUESTO - 1C:B12",
      "1346:PRESUPUESTO - 1D:B13"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 3,
    "linea": "Camara de aire",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "ESTRUCTURA DE CUBIERTA",
    "fuenteIds": [
      "1347:PRESUPUESTO CASA:A12"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": true,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 3,
    "linea": "Frescasa",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "CUBIERTA y PAREDES",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A12",
      "1342:PRESUPUESTO CASA:A24",
      "1346:PRESUPUESTO - 1C:B28"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 3,
    "linea": "Correas en madera inmunizada",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "ESTRUCTURA DE CUBIERTA",
    "fuenteIds": [
      "1346:PRESUPUESTO - 1C:B12",
      "1346:PRESUPUESTO - 1D:B12",
      "1346:PRESUPUESTO - HALL:B24"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 3,
    "linea": "Teja",
    "obligatoria": false,
    "opciones": [
      "UPVC",
      "Shingle (rojo/verde/negro)",
      "Monoroof",
      "barro",
      "techoline",
      "plana sigma",
      "eternit"
    ],
    "seccionCatalogo": "ESTRUCTURA DE CUBIERTA / CUBIERTAS",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A12",
      "4546:PRESUPUESTO CASA:A12",
      "APU:APU:B29",
      "APU:APU:B30",
      "APU:APU:B28",
      "APU:APU:B31",
      "APU:APU:B32",
      "APU:APU:B33"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 3,
    "linea": "Claraboyas o tragaluz",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "ESTRUCTURA DE CUBIERTA / HALL",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A13",
      "1346:PRESUPUESTO - 1D:B18",
      "1346:PRESUPUESTO - HALL:B26"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 3,
    "linea": "Tapas perimetrales",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "ESTRUCTURA DE CUBIERTA",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A14",
      "1347:PRESUPUESTO CASA:A13",
      "4546:PRESUPUESTO CASA:A13"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 3,
    "linea": "Canoas",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "ESTRUCTURA DE CUBIERTA / HALL",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A15",
      "1346:PRESUPUESTO - 1C:B15",
      "1346:PRESUPUESTO - HALL:B25"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 3,
    "linea": "Cerchas",
    "obligatoria": true,
    "opciones": [],
    "seccionCatalogo": "ESTRUCTURA DE CUBIERTA",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A16",
      "1346:PRESUPUESTO - 1C:B14",
      "1347:PRESUPUESTO CASA:A15"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 4,
    "linea": "Salidas hidrosanitarias",
    "obligatoria": true,
    "opciones": [],
    "seccionCatalogo": "SALIDAS HIDROSANITARIAS Y DE GAS",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A35",
      "1346:PRESUPUESTO - 1C:B53",
      "4546:PRESUPUESTO CASA:A44"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 4,
    "linea": "Salidas de gas",
    "obligatoria": true,
    "opciones": [],
    "seccionCatalogo": "idem",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A36",
      "1346:PRESUPUESTO - 1C:B54",
      "4546:PRESUPUESTO CASA:A45"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 4,
    "linea": "Pozo septico",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "SALIDAS HIDRO / POSO SEPTICO / ADICIONALES",
    "fuenteIds": [
      "1346:PRESUPUESTO - POSO SEPTICO:B12",
      "4546:PRESUPUESTO CASA:A46",
      "1342:PRESUPUESTO CASA:A37"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 4,
    "linea": "Hidroflow",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": null,
    "fuenteIds": [],
    "porConfirmar": true,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 4,
    "linea": "Recoleccion de aguas lluvias",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "ADICIONALES OBRA",
    "fuenteIds": [
      "1346:PRESUPUESTO - 1C:B139",
      "1346:PRESUPUESTO - 1D:B130"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 4,
    "linea": "Acometida hidrosanitaria",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "SALIDAS HIDROSANITARIAS",
    "fuenteIds": [
      "4546:PRESUPUESTO CASA:A46",
      "1342:PRESUPUESTO CASA:A37"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": "acometida de agua potable: por confirmar"
  },
  {
    "capitulo": 5,
    "linea": "Salidas electricas 110 V",
    "obligatoria": true,
    "opciones": [],
    "seccionCatalogo": "SALIDAS ELECTRICAS",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A40",
      "4546:PRESUPUESTO CASA:A49",
      "1346:PRESUPUESTO - 1C:B57"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 5,
    "linea": "Salidas electricas 220 V",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "SALIDAS ELECTRICAS",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A41",
      "4546:PRESUPUESTO CASA:A50"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 5,
    "linea": "Varilla coperweld",
    "obligatoria": true,
    "opciones": [],
    "seccionCatalogo": "idem",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A40",
      "1346:PRESUPUESTO - 1C:B57",
      "4546:PRESUPUESTO CASA:A49"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": true,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 5,
    "linea": "Caja de breakers",
    "obligatoria": true,
    "opciones": [],
    "seccionCatalogo": "idem",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A40",
      "4546:PRESUPUESTO CASA:A49",
      "1346:PRESUPUESTO - 1C:B57"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": true,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 5,
    "linea": "Acometida electrica",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "SALIDAS ELECTRICAS",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A41",
      "4546:PRESUPUESTO CASA:A50"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": true,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 6,
    "linea": "Puertas en madera maciza",
    "obligatoria": true,
    "opciones": [],
    "seccionCatalogo": "CARPINTERIA EN MADERA",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A45",
      "4546:PRESUPUESTO CASA:A54",
      "1346:PRESUPUESTO - 1D:B75"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 6,
    "linea": "Puertas en madera entamborada",
    "obligatoria": true,
    "opciones": [],
    "seccionCatalogo": "idem",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A44",
      "1346:PRESUPUESTO - 1C:B73",
      "1347:PRESUPUESTO CASA:A40"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 6,
    "linea": "Muebles de WC",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "idem",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A47",
      "1346:PRESUPUESTO - 1C:B69",
      "4546:PRESUPUESTO CASA:A56"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 6,
    "linea": "Mueble de lavadero",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "idem",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A46",
      "1346:PRESUPUESTO - 1C:B72",
      "4546:PRESUPUESTO CASA:A57"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 6,
    "linea": "Pasamanos",
    "obligatoria": false,
    "opciones": [
      "madera inmunizada",
      "teka",
      "macana",
      "estructura metalica",
      "cable acerado"
    ],
    "seccionCatalogo": "ESTRUCTURA METALICA / PASAMANOS",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A67",
      "4546:PRESUPUESTO CASA:A79",
      "1346:PRESUPUESTO - 1C:B49",
      "APU:APU:J13"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": "macana: por confirmar"
  },
  {
    "capitulo": 6,
    "linea": "Cocina",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "CARPINTERIA EN MADERA",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A48",
      "1346:PRESUPUESTO - 1C:B60",
      "1346:PRESUPUESTO - 1C:B61"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 6,
    "linea": "Vestier",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "CARPINTERIA EN MADERA",
    "fuenteIds": [
      "1346:PRESUPUESTO - 1C:B64",
      "1346:PRESUPUESTO - 1C:B65",
      "1346:PRESUPUESTO - 1D:B65"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 6,
    "linea": "Closet",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "CARPINTERIA EN MADERA",
    "fuenteIds": [
      "1346:PRESUPUESTO - 1D:B67"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 7,
    "linea": "Ventanas",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "CARPINTERIA EN ALUMINIO / HALL",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A52",
      "4546:PRESUPUESTO CASA:A62",
      "1346:PRESUPUESTO - 1C:B82"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 7,
    "linea": "Puertas",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "idem",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A51",
      "4546:PRESUPUESTO CASA:A60",
      "1346:PRESUPUESTO - 1C:B89"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 7,
    "linea": "Cabinas de WC",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "idem",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A63",
      "4546:PRESUPUESTO CASA:A74",
      "1346:PRESUPUESTO - 1C:B91"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 8,
    "linea": "Enchape de pisos",
    "obligatoria": false,
    "opciones": [
      "madera",
      "ceramicos",
      "laminados",
      "porcelanato",
      "gres",
      "SPC",
      "piedras",
      "cemento pulido",
      "resina epoxica"
    ],
    "seccionCatalogo": "ENCHAPES",
    "fuenteIds": [
      "1347:PRESUPUESTO CASA:A53",
      "1346:PRESUPUESTO - 1C:B100",
      "1346:PRESUPUESTO - 1D:B96",
      "1342:PRESUPUESTO CASA:A71",
      "4546:PRESUPUESTO CASA:A82"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": "gres, SPC, cemento pulido y epoxica: por confirmar"
  },
  {
    "capitulo": 8,
    "linea": "Enchape de paredes",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "ENCHAPES",
    "fuenteIds": [
      "1347:PRESUPUESTO CASA:A57",
      "4546:PRESUPUESTO CASA:A86",
      "1342:PRESUPUESTO CASA:A75"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 8,
    "linea": "Enchape salpique de cocina",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "ENCHAPES",
    "fuenteIds": [
      "1346:PRESUPUESTO - 1C:B104",
      "1342:PRESUPUESTO CASA:A80",
      "1347:PRESUPUESTO CASA:A61"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 9,
    "linea": "Sanitario",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "ACABADOS",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A83",
      "1346:PRESUPUESTO - 1C:B107",
      "1347:PRESUPUESTO CASA:A64"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 9,
    "linea": "Lavamanos",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "ACABADOS",
    "fuenteIds": [
      "1346:PRESUPUESTO - 1C:B108",
      "1346:PRESUPUESTO - 1D:B104"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 9,
    "linea": "Juego de incrustaciones",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "ACABADOS",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A84",
      "1346:PRESUPUESTO - 1C:B112",
      "1347:PRESUPUESTO CASA:A65"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 9,
    "linea": "Griferias",
    "obligatoria": false,
    "opciones": [
      "ducha",
      "lavamanos",
      "lavaplatos"
    ],
    "seccionCatalogo": "ACABADOS",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A85",
      "1342:PRESUPUESTO CASA:A86",
      "1346:PRESUPUESTO - 1C:B110"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 9,
    "linea": "Caja de lavadora y llaves",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "ACABADOS",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A93",
      "1346:PRESUPUESTO - 1C:B115",
      "1346:PRESUPUESTO - 1C:B116"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 9,
    "linea": "Sifon flexible",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "ACABADOS",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A87",
      "1347:PRESUPUESTO CASA:A68",
      "1346:PRESUPUESTO - 1C:B118"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 9,
    "linea": "Desague push",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "ACABADOS",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A88",
      "1347:PRESUPUESTO CASA:A69",
      "1346:PRESUPUESTO - 1C:B120"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 9,
    "linea": "Llave de abasto",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "ACABADOS",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A89",
      "1347:PRESUPUESTO CASA:A70",
      "4546:PRESUPUESTO CASA:A104"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 9,
    "linea": "Manguera de abasto",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "ACABADOS",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A90",
      "1346:PRESUPUESTO - 1C:B117",
      "1347:PRESUPUESTO CASA:A71"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 9,
    "linea": "Llave bocamanguera",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "ACABADOS",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A91",
      "1346:PRESUPUESTO - 1C:B114",
      "4546:PRESUPUESTO CASA:A106"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 9,
    "linea": "Rejilla de piso",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "ACABADOS",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A92",
      "1346:PRESUPUESTO - 1C:B122",
      "1347:PRESUPUESTO CASA:A73"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 9,
    "linea": "Canastilla de lavaplatos",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "ACABADOS",
    "fuenteIds": [
      "1346:PRESUPUESTO - 1C:B119",
      "1346:PRESUPUESTO - 1D:B115"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 9,
    "linea": "Acabados en pintura de madera",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": null,
    "fuenteIds": [
      "4546:PRESUPUESTO CASA:A34"
    ],
    "porConfirmar": true,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 9,
    "linea": "Instalacion de WC",
    "obligatoria": false,
    "opciones": [],
    "seccionCatalogo": "ENCHAPES",
    "fuenteIds": [
      "1346:PRESUPUESTO - 1C:B101",
      "1342:PRESUPUESTO CASA:A76",
      "4546:PRESUPUESTO CASA:A92"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": true,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 10,
    "linea": "Viaticos",
    "obligatoria": true,
    "opciones": [],
    "seccionCatalogo": "FINALES OBRA",
    "fuenteIds": [
      "1346:PRESUPUESTO - 1D:B121",
      "1346:PRESUPUESTO - 1C:B130"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 10,
    "linea": "Acarreos o transportes",
    "obligatoria": true,
    "opciones": [],
    "seccionCatalogo": "FINALES OBRA",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A99",
      "1347:PRESUPUESTO CASA:A76",
      "4546:PRESUPUESTO CASA:A114"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 10,
    "linea": "Andamios",
    "obligatoria": true,
    "opciones": [],
    "seccionCatalogo": "FINALES OBRA",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A99",
      "4546:PRESUPUESTO CASA:A114",
      "1346:PRESUPUESTO - 1D:B121"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 10,
    "linea": "Herramientas y equipos",
    "obligatoria": true,
    "opciones": [],
    "seccionCatalogo": "FINALES OBRA",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A99",
      "1347:PRESUPUESTO CASA:A76",
      "4546:PRESUPUESTO CASA:A114"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  },
  {
    "capitulo": 10,
    "linea": "Aseo de obra",
    "obligatoria": true,
    "opciones": [],
    "seccionCatalogo": "FINALES OBRA",
    "fuenteIds": [
      "1342:PRESUPUESTO CASA:A99",
      "1346:PRESUPUESTO - 1D:B121",
      "1346:PRESUPUESTO - 1C:B130"
    ],
    "porConfirmar": false,
    "dentroDeOtroItem": false,
    "notaPorConfirmar": null
  }
];
